import React, { useEffect } from 'react';
import { CheckIcon } from '../../../components/ui/Icons';
import { EVIDENCE_REVIEWED_ITEMS } from '../capaEffectivenessConstants';

export { EVIDENCE_REVIEWED_ITEMS };

/**
 * Read-only Evidence Reviewed list with check icons (form boilerplate).
 * Persists all evidence flags as true on create so the snapshot matches the form.
 */
const CapaEffectivenessEvidenceReviewed = ({ formData, setFormData }) => {
  useEffect(() => {
    if (typeof setFormData !== 'function') return;
    if (formData?.id) return;

    setFormData((prev) => {
      if (!prev) return prev;
      let changed = false;
      const next = { ...prev };
      EVIDENCE_REVIEWED_ITEMS.forEach(({ field }) => {
        if (next[field] !== true) {
          next[field] = true;
          changed = true;
        }
      });
      return changed ? next : prev;
    });
  }, [formData?.id, setFormData]);

  return (
    <div className="space-y-3">
      <p className="text-sm text-slate-600 dark:text-slate-300">
        Evidence reviewed:
      </p>
      <ul className="grid grid-cols-1 gap-2.5 md:grid-cols-2">
        {EVIDENCE_REVIEWED_ITEMS.map(({ field, label }) => (
          <li
            key={field}
            className="flex items-start gap-3 rounded-lg border border-emerald-100 bg-emerald-50/60 px-3 py-2.5 dark:border-emerald-900/40 dark:bg-emerald-950/30"
          >
            <span
              className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-emerald-500 text-white shadow-sm"
              aria-hidden="true"
            >
              <CheckIcon className="h-3 w-3" />
            </span>
            <span className="text-sm leading-snug text-slate-800 dark:text-slate-100">
              {label}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default CapaEffectivenessEvidenceReviewed;
